import React from 'react';
import { ShoppingBag } from 'lucide-react';

const ShopEmptyState = ({ onClearFilters }) => {
  return (
    <div className="shop-empty-state">
      <div className="empty-state-icon-wrapper">
        <ShoppingBag size={48} />
      </div>
      <h3 className="empty-state-title">No Products Found</h3>
      <p className="empty-state-subtitle">
        We couldn't find any wholesale items matching your search keywords or active filter criteria.
      </p>
      <button onClick={onClearFilters} className="btn-empty-clear">
        Clear All Filters
      </button>
    </div>
  );
};

export default ShopEmptyState;
